<template>
  <v2-row noSpace>
    <v2-col col12 noSpaceX noSpace>
      <v2-redactor
        :label="$t('quickLaunch.labels.content')"
        :placeholder="$t('forms.required')"
        minHeight="300px"
        v-model="text"
        v-validate="'required'"
        name="content"
        @input="setChangedComp()"
        :error="errors.first('content')"
        :data-vv-as="$t('quickLaunch.labels.content')"
      />
    </v2-col>
    <v2-col col12 class="items-end" noSpaceX noSpace>
      <v2-button outline primary @click.native="saveComponent(false)">{{ $t("quickLaunch.actions.save") }}</v2-button>
    </v2-col>
  </v2-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QuickLaunchTitle",
  props: {
    component: Object,
  },
  data() {
    return {
      hasChanged: false,
      text: "",
    };
  },
  created() {
    this.text = this.component.value.textContent;
    this.$eventbus.$on("saveComponents", () => {
      this.saveComponent(true);
    });
  },
  methods: {
    ...mapActions(["updateComponent", "getProjectComponent"]),
    setChangedComp() {
      this.hasChanged = true;
      this.$eventbus.$emit("setUnsavedComponents", this.component.uid);
    },
    saveComponent(isEvent = false) {
      if (this.hasChanged) {
        const vm = this;
        const data = {
          customLoading: true,
          params: {
            project: vm.currentProject.uid,
            component: vm.component.uid,
          },
          data: {
            value: {
              textContent: vm.text,
            },
          },
        };
        vm.$validator.validateAll().then((result) => {
          if (result) {
            vm.updateComponent(data)
              .then(() => {
                vm.$eventbus.$emit("componentSavedSuccess", this.component.uid, isEvent);
                vm.hasChanged = false;
                if (!isEvent) {
                  vm.$snotify.success(vm.$t("quickLaunch.toasts.saveComponent.success"), vm.$t("toasts.success"), {
                    icon: vm.$successIcon,
                  });
                  vm.reloadComponent();
                }
              })
              .catch(() => {
                vm.$eventbus.$emit("componentSavedError", this.component.uid);
                if (!isEvent) {
                  vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.error"), vm.$t("toasts.error"), {
                    timeout: 0,
                    icon: vm.$errorIcon,
                  });
                }
              });
          } else {
            vm.$eventbus.$emit("componentSavedError", this.component.uid);
            if (!isEvent) {
              vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.validation"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            }
          }
        });
      }
    },
    reloadComponent() {
      this.getProjectComponent({
        customLoading: true,
        params: {
          project: this.currentProject.uid,
          component: this.component.uid,
        },
      }).then(() => {});
    },
  },
  computed: {
    ...mapGetters({
      currentProject: "projects_get_current_project",
    }),
  },
};
</script>

<style lang="scss"></style>
